import {nanoid} from 'nanoid';
import {useCallback} from 'react';

import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics/logEvent';

type LogSearchResultsClickProps = {
  query: string;
  position: number;
  appId: string;
  currentCategory: string;
};

export const useAppCardAnalytics = () => {
  const getUserId = useGetVkId();

  const logAppsAppSelect = useCallback(
    (packageName: string) => {
      logTmrEvent({
        logEvent: 'app.select',
        params: {
          app_id: packageName,
          vk_id: getUserId(),
        },
      });
    },
    [getUserId],
  );

  const logAppCategoryAppSelect = useCallback(
    (packageName: string, appCategoryName: string) => {
      logTmrEvent({
        logEvent: 'appCategory.app.select',
        params: {
          app_id: packageName,
          app_category_name: appCategoryName,
          vk_id: getUserId(),
        },
      });
    },
    [getUserId],
  );

  const logGamesGameSelect = useCallback(
    (packageName: string) => {
      logTmrEvent({
        logEvent: 'games.game.select',
        params: {
          app_id: packageName,
          vk_id: getUserId(),
        },
      });
    },
    [getUserId],
  );

  const logGameCategoryGameSelect = useCallback(
    (packageName: string, appCategoryName: string) => {
      logTmrEvent({
        logEvent: 'gameCategory.game.select',
        params: {
          app_id: packageName,
          app_category_name: appCategoryName,
          vk_id: getUserId(),
        },
      });
    },
    [getUserId],
  );

  const logSearchResultsClick = useCallback(
    ({query, position, appId, currentCategory}: LogSearchResultsClickProps) => {
      logTmrEvent({
        logEvent: 'searchResults.click',
        params: {
          app_category_name: currentCategory,
          q_id: nanoid(),
          query,
          position,
          app_id: appId,
          vk_id: getUserId(),
        },
      });
    },
    [getUserId],
  );

  return {
    logAppsAppSelect,
    logAppCategoryAppSelect,
    logGamesGameSelect,
    logGameCategoryGameSelect,
    logSearchResultsClick,
  };
};
